<template lang="html">
  <process-interview-scene
    v-if="interview"
    :loading="loading"
    :interview="interview"
    :vacancy="vacancy"
    :from-registration="fromRegistration"
    :error="error"
    :fetch="fetch"
  />
</template>

<script>
export default {
  name: 'InterviewScene',

  props: {
    token: String,
    fromRegistration: Boolean
  },

  computed: {
    loading() {
      return this.$store.getters['interview/loading'];
    },

    interview() {
      return this.$store.getters['interview/one'];
    },

    vacancy() {
      return this.$store.getters['interview/vacancy'];
    },

    locale() {
      return this.$store.getters['locale/current'];
    },

    error() {
      return this.$store.getters['interview/error'];
    }
  },

  watch: {
    token() {
      this.fetch();
    },

    interview(val) {
      if (!val) {
        return;
      }

      const vacancyLanguage = val.vacancy && val.vacancy.language ? val.vacancy.language.code : null;

      if (vacancyLanguage && this.locale !== vacancyLanguage) {
        this.$store.dispatch('locale/change', vacancyLanguage);
      }
    }
  },

  beforeMount() {
    this.fetch();
  },

  methods: {
    fetch() {
      if (this.token) {
        this.$store.dispatch('interview/fetch', {
          token: this.token
        });
      }
    }
  }
};
</script>
